<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="account" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Account Profile</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list class="ion-text-wrap">

        <ion-item-divider color="tertiary">
            General
        </ion-item-divider>

        <ion-item id="accountNumber">
            <ion-label class="ion-text-wrap">
                <span class="line1">Account Number</span><br />
                <span class="line2">{{accountProfile?.accountNumber}}</span>
            </ion-label>
        </ion-item>
        
        <ion-item id="dealershipName">
            <ion-label class="ion-text-wrap">
                <span class="line1">Dealership</span><br />
                <span class="line2">{{dealership?.dealershipName}}</span><br />
                <span class="line2">{{dealership?.phoneNumber | myPhone}}</span><br />
                <span class="line2">{{dealership?.address?.fullAddress}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="signUpDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sign Up Date</span><br />
                <span class="line2">{{accountProfile?.signupDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Activation Details
        </ion-item-divider>

        <ion-item id="activationDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Activation Date</span><br />
                <span class="line2">{{getActivationDate()}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="activationDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Activation Order Number</span><br />
                <span class="line2">{{getActivationOrderNumber()}}</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Package Details
        </ion-item-divider>

        <ion-item id="package">
            <ion-label class="ion-text-wrap">
                <span class="line1">Current Package</span><br />
                <span class="line2">{{accountProfile?.packageName}}</span><br />
            </ion-label>
        </ion-item>

        <!-- I don't think I need to show the package type anymore
        <ion-item id="type">
            <ion-label class="ion-text-wrap">
                <span class="line1">Package Type</span><br />
                <span class="line2">{{accountProfile?.type}}</span><br />
            </ion-label>
        </ion-item> 
        -->

        <ion-item id="status">
            <ion-label class="ion-text-wrap">
                <span class="line1">Status</span><br />
                <span class="line2">{{accountProfile?.status}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="startDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Package Start Date</span><br />
                <span class="line2">{{periodInfo?.startDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
                </ion-label>
        </ion-item>

        <ion-item id="expirationDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Package Expiration Date</span><br />
                <span class="line2">{{periodInfo?.expirationDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
                </ion-label>
        </ion-item>

        @if (accountProfile?.type == 'Pay As You Go') {
        <div>
            <ion-item>
                <ion-label class="ion-text-wrap">
                    <span class="line1">Available Credits</span><br />
                    <span class="line2">{{creditInfo?.availableCredits}}</span>
                </ion-label>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap">
                    <span class="line1">Credits Last Purchased</span><br />
                <span class="line2">{{creditInfo?.lastCreditPurchaseDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
            </ion-item>
        </div>
        }
        
        <ion-item-divider color="tertiary">
            Features Details
        </ion-item-divider>

        <ion-item id="premiumSupportExpirationDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Premium Support Expiration Date</span><br />
                <span class="line2">{{periodInfo?.premiumSupportExpirationDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
                </ion-label>
        </ion-item>

        <ion-item id="webHostingExpirationDate">
            <ion-label class="ion-text-wrap">
                <span class="line1">Web Hosting Expiration Date</span><br />
                <!-- <span class="line2">{{accountProfile?.periodInfo?.webHostingExpirationDate | 
                        myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}
                </span> -->
                <span class="line2">{{periodInfo?.webHostingExpirationDate | 
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
        </ion-label>
        </ion-item>

        <ion-item id="lockedInPricing">
            <ion-label class="ion-text-wrap">
                <span class="line1">Locked In Pricing</span><br />
                <span class="line2">{{getLockedInPricingStr()}}</span><br />
                @if (getLockedInPricingStr()=='Active') {
                <div>
                    <!-- <ion-label class="ion-text-wrap">
                        <span class="line2">Name: {{accountProfile?.pricingInfo.priceName}}</span><br />
                        <span class="line2">Pay As You Go Base Price: {{accountProfile?.pricingInfo.paygBasePrice | myCurrency}}</span><br />
                        <span class="line2">Pay As You Go Customer Message Credits: {{accountProfile?.pricingInfo.paygCreditsCostPerCustomerMsg}}</span><br />
                        <span class="line2">Pay As You Go Campaign Message Credits: {{accountProfile?.pricingInfo.paygCreditsCostPerCampaignMsg}}</span><br />
                        <span class="line2">Unlimited Monthly Base Price: {{accountProfile?.pricingInfo.unlimitedMonthlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Unlimited Yearly Base Price: {{accountProfile?.pricingInfo.unlimitedYearlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Ambassador Yearly Base Price: {{accountProfile?.pricingInfo.ambassadorYearlyBasePrice | myCurrency}}</span><br />
                    </ion-label>     -->
                    <ion-label class="ion-text-wrap">
                        <span class="line2">Name: {{pricingInfo.priceName}}</span><br />
                        <span class="line2">Pay As You Go Base Price: {{pricingInfo.paygBasePrice | myCurrency}}</span><br />
                        <span class="line2">Pay As You Go Customer Message Credits: {{pricingInfo.paygCreditsCostPerCustomerMsg}}</span><br />
                        <span class="line2">Pay As You Go Campaign Message Credits: {{pricingInfo.paygCreditsCostPerCampaignMsg}}</span><br />
                        <span class="line2">Unlimited Monthly Base Price: {{pricingInfo.unlimitedMonthlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Unlimited Yearly Base Price: {{pricingInfo.unlimitedYearlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Ambassador Yearly Base Price: {{pricingInfo.ambassadorYearlyBasePrice | myCurrency}}</span><br />
                    </ion-label>    
                </div>
            }
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Efficiency Features</span><br />
                <span class="line2">{{getEfficiencyStr()}}</span>
            </ion-label>
        </ion-item>
        
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Customer Features</span><br />
                <span class="line2">{{getCustomerStr()}}</span>
            </ion-label>
        </ion-item>
        
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Campaign Features</span><br />
                <span class="line2">{{getCampaignStr()}}</span>
            </ion-label>
        </ion-item>
        
        <ion-item-divider color="tertiary">
            Other
        </ion-item-divider>
        
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Notes</span><br />
                <span class="line2">
                    To manage your account, please go to the ShuttleNomix website and login.  From there you
                    will be able to make payments, upgrade or downgrade your package and even cancel.  If you 
                    have any questions about your account, please contact us. Our contact information is shown
                    on the 'Contact Us' page. Click on 'Help' and then click on 'Contact Us'.
                </span>
            </ion-label>
        </ion-item>

    </ion-list>
</ion-content>

@if (accountProfile.debug) {
  <ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onResetClick()">Reset</ion-button>
    </ion-toolbar>
</ion-footer>
}
